var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAttention = function SvgAttention(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#attention_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4797FF",
    d: "M14 16c0 .83-.67 1.5-1.5 1.5S11 16.83 11 16s.67-1.5 1.5-1.5 1.5.67 1.5 1.5Zm3.5-12.15v2.41c1.83 1.47 3 3.71 3 6.24 0 4.42-3.58 8-8 8s-8-3.58-8-8c0-2.53 1.17-4.77 3-6.24V3.85c-2.99 1.73-5 4.95-5 8.65 0 5.52 4.48 10 10 10s10-4.48 10-10c0-3.7-2.01-6.92-5-8.65Zm-4 7.65v-9c0-.55-.45-1-1-1s-1 .45-1 1v9c0 .55.45 1 1 1s1-.45 1-1Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "attention_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.5 1.5h20v21h-20z"
  })))));
};
export default SvgAttention;